import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent, SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import { ReactNode } from 'react';

export interface SelectOption {
  value: string;
  label: string;
}

export interface FormSelectProps extends Omit<SelectProps<string>, 'onChange'> {
  label: string;
  options: SelectOption[];
  value: string;
  onChange: (event: SelectChangeEvent<string>, child: ReactNode) => void;
  helperText?: string;
  fullWidth?: boolean;
}

export function FormSelect({
  label,
  options,
  value,
  onChange,
  error,
  helperText,
  fullWidth = true,
  required,
  disabled,
  ...props
}: FormSelectProps) {
  const labelId = `${label.toLowerCase().replace(/\s+/g, '-')}-label`;

  return (
    <FormControl fullWidth={fullWidth} error={error} required={required} disabled={disabled}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value}
        onChange={onChange}
        {...props}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
